import service from "@irati/utils/tracking/index"

const tracking = {}

tracking.viewRewards = () => {
  service.trackRecognitionEvent("recognition_view_reward")
}
tracking.viewRecognition = () => {
  service.trackRecognitionEvent("recognition_view_recognition")
}

tracking.viewSummary = () => {
  service.trackRecognitionEvent("recognition_view_summary")
}

tracking.viewProfile = () => {
  service.trackRecognitionEvent("recognition_view_profile")
}

tracking.clickMyCelebrations = (data) => {
  service.trackRecognitionEvent("celebrations_click_my_celebrations", data)
}

export default tracking
